export const setIsLoading = function ({commit}, isLoading) {
    commit('SET_IS_LOADING', isLoading);
};

export const setIsShow = function ({commit}, isShow) {
    commit('SET_IS_SHOW', isShow);
};

export const setIsPrint = function ({commit}, isPrint) {
    commit('SET_IS_PRINT', isPrint);
};

export const setIsPreview = function ({commit}, isPreview) {
    commit('SET_IS_PREVIEW', isPreview);
};

export const setIsFirstLoaded = function ({commit}, isFirstLoaded) {
    commit('SET_IS_FIRST_LOADED', isFirstLoaded);
};

export const setDateTime = function ({commit}, datetime) {
    commit('SET_DATETIME', datetime);
};

export const setPostSpend = function ({commit}, data) {
    commit('SET_POST_SPEND', data);
};

export const setPages = function ({commit}, response) {
    commit('SET_PAGES', response);
};

export const setOwnPage = function ({commit}, ownPage) {
    commit('SET_OWN_PAGE', ownPage);
};

export const updateBudgetSpend = function ({commit}, data) {
    commit('UPDATE_BUDGET_SPEND', data);
};

export const updateCPM = function ({commit}, data) {
    commit('UPDATE_CPM', data);
};

export const updateCPA = function ({commit}, data) {
    commit('UPDATE_CPA', data);
};

export const updateCTR = function ({commit}, data) {
    commit('UPDATE_CTR', data);
};

export const addMyApp = function ({commit}, data) {
    commit('ADD_MY_APP', data);
};

export const deleteMyApp = function ({commit}, id) {
    commit('DELETE_MY_APP', id);
};

export const favouriteMyApp = function ({commit}, data) {
    commit('FAVOURITE_MY_APP', data);
};

export const setAppVersion = function ({commit}, version) {
    commit('SET_APP_VERSION', version);
};

export const setOwnPageData = function ({commit}, response) {
    commit('SET_OWN_PAGE_DATA', response);
};

export const setCompetitorBenchmark = function ({commit}, response) {
    commit('SET_COMPETITOR_BENCHMARK', response);
};

export const setOwnPagePosts = function ({commit}, response) {
    commit('SET_OWN_PAGE_POSTS', response);
};

export const setAverageBenchmarks = function ({commit}) {
    commit('SET_AVERAGE_BENCHMARKS');
};








